import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import './authorized.scss';
import { loadTransportList } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { getProfileData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import Grid from '../../../components/base/Grid/Grid';
import { applicantTypeFormatter } from '../../../utils/formatters';

export function UserTransportDataView(props) {
  const {
    formatMessage,
  } = intlShape;
  const {
    userId = '',
  } = props;

  const columns = [
    {
      dataField: 'vehicle_lpn',
      text: 'ГРН ТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'name',
      text: 'Марка/Модель ТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'vehicle_registration_number',
      text: 'СТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
  ];

  const dispatch = useDispatch();
  const {
    transportList, loadingTransportList,
  } = useSelector(getProfileData);

  useEffect(() => {
    dispatch(loadTransportList({
      filter: {
        userId,
      },
    })).catch(responseLogWithNotification);
  }, []);

  return (
    <div>
      <div className="f3">{formatMessage({ id: 'user.profile.menu.transport' })}</div>
      <div className="mb-4" />
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <Grid data={transportList} columns={columns} />
        </div>
        <Loader loading={loadingTransportList} />
      </div>
    </div>
  );
}
